import { apiFetch } from "../base";

export function * getProfile (payload) {
	return yield apiFetch({
		endpoint: "/auth/v1/auth/profile",
		method: "GET",
		authenticated: true
	});
}
